import { useEffect } from 'react';

export default function TrelloCallback() {
  useEffect(() => {
    const hash = new URLSearchParams(window.location.hash.slice(1));
    const token = hash.get('token');

    if (token) {
      // Obtém o token de autenticação do localStorage
      const authData = localStorage.getItem('impersonating-auth-token');
      let authToken = null;
      
      if (authData) {
        try {
          const parsed = JSON.parse(authData);
          authToken = parsed.api_token;
        } catch (e) {
          console.error('[TrelloCallback] Error parsing auth data:', e);
        }
      }
      
      if (!authToken) {
        console.error('[TrelloCallback] No auth token found');
        window.location.replace('/admin/integrations?trello=error');
        return;
      }

      fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/trello/save-token`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({ token }),
      })
        .then(() => window.location.replace('/admin/integrations?trello=ok'))
        .catch((e) => {
          console.error('[TrelloCallback] save-token error', e);
          window.location.replace('/admin/integrations?trello=error');
        });
    } else {
      console.warn('[TrelloCallback] token missing in hash');
      // Optional: window.location.replace('/admin/integrations?trello=missing_token');
    }
  }, []);

  return <div>Processing Trello callback…</div>;
}
